export default "__VITE_ASSET__DULsdWbc__"